import { render } from "./WarningMessage.vue?vue&type=template&id=2fd30451"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"
script.render = render

export default script